import PropTypes from 'prop-types';
import AddressProps from './address';

export const Station = PropTypes.shape({
  name: PropTypes.string.isRequired,
  id: PropTypes.number,
  numRatings: PropTypes.number,
  enterprise: PropTypes.bool,
  address: AddressProps.isRequired,
  phone: PropTypes.string,
});

export default Station;
